<template>
	<div>
		<compWrapper title="对应关系" theme="primary">
			<compFormQuery v-if="query" :formdata="getRelation" :value="formData" :labelWidth="235"></compFormQuery>
			<compFormEdit v-else ref="relation" class="margin-top-15 clearfix" :formdata="getRelation" v-model="formData" :labelWidth="235"/>
		</compWrapper>
		<compWrapper title="其他信息" theme="info">
			<compFormQuery v-if="query" :formdata="getOthernews" :value="formData" :labelWidth="235"></compFormQuery>
			<compFormEdit v-else class="margin-top-15 clearfix" :formdata="getOthernews" v-model="formData" :labelWidth="235"/>
		</compWrapper>
		<div v-if="!query" class="text-right" v-show="type!='query'">
			<Button type="primary" class="width-15per" @click="submit">提交</Button>
            <Button class="width-15per margin-left-10" @click="cancel">取消</Button>
		</div>
		<compWrapper title="操作历史" theme="gray" v-if="query">
			<compLog class="margin-15" :data="logList"></compLog>
		</compWrapper>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpQueryPlatform, HttpSavePlatform } from "@/service/managechannel/managechannel";
import { HttpSysOpLogNew } from '@/service/boss/allot';
import { mapState, mapGetters } from "vuex";
import platTablelist from "./platTablelist.vue";
import systemTablelist from "../../publictable/systemTablelist.vue"
import compLog from "./log"
export default {
	props:['activeids','querytype'],
	components: {
		// compWrapper: () => import("@components/templates/wrapper"),
		// compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		platTablelist,
		systemTablelist,
		compLog,
	},
	data() {
		return {
			type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeids,
			query: false,
			getOtherBase: [],
			opLogList: [],
			formData: {
				channelCategoriesId:0,
				siteCountry:"",
				trackingMethodCode:"",
				shippingS:false,
			},
			LogformData: {
				page: 1,
				rows: 10,
				sidx: 'id',
                sord: 'desc',
                "search[EQ_opModel]":'AccountSiteShipment',
                "search[EQ_opDataId]":this.$route.query.id || this.activeids,
            },
			logList:[],
			loading:false,
		}
	},
	created() {
		this.query = this.type === "query";
		if (this.type === "query" || this.type === "edit") {
			this.getDetail()
		}
	},
	computed: {
		...mapState('boss',['sysdeliveries','syscarrier','sysservice','accounts','countries', 'newSysdeliveries', 'newSysCarrier']),
		...mapGetters('diction',['getNewAccountList','getNewAllAccountIdList']),
		getRelation() {
			let showquery = this.type == 'edit' || this.type == 'query'
			let showtrue = this.type!='edit' && this.type!='query'
			return [
				{
					label: "平台名称",
					key: "siteName",
					span: 24,
					query:showquery,
					show:showquery,
				},
				{
					label: "平台名称",
					key: "siteName",
					span: 24,
					show:!showquery,
					props:{
						readonly:true
					},
					children:(h)=>{
						return <vIcon
						type="search"
						center
						slot="suffix"
						style="padding:6px;pointer-events: initial;"
						size="18"
						nativeOnClick={this.handleModalplat.bind(this)}
					/>
					},
					formItem:{
						style:"width:50%"
					},
				},
				{
					label: "平台Shipping carrier",
					key: "shippingCarrier",
					required:false,
					props:{
						disabled:this.formData.shippingS
					},
				},
				{
					// label: "平台Shipping carrier",
					key: "shippingS",
					tag:"vCheckBox",
					labelWidth: 0,
					required:false,
					show:this.type != 'query',
					span:2,
					on:{
						'on-change':function(labelValue){
							this.$VModal.default({
                                title: "提示",
                                // width: 800,
                                content: "<div class='text-center'>选择不指定，适用于平台订单不指定carrier的平台（如Amazon等</div>",
                            },{
                                'on-cancel': () => {
									this.$set(this.formData,'shippingS',false)
                                },
                                'on-confirm': () => {
									this.$set(this.formData,'shippingS',true)
									this.$set(this.formData,'shippingCarrier','DEFAULT')
									this.$set(this.formData,'shippingMethodCode','DEFAULT')
                                    this.$VModal.destroy();
                                }
                            })
						}
					},
					props:{
						label:"不指定",
						trueValue:true,
					},
				},
				{
					label: "平台Shipping Service/Method Code",
					span:24,
					key: "shippingMethodCode",
					required:false,
					formItem:{
						style:"width:50%"
					},
					props:{
						disabled:this.formData.shippingS
					}
				},
				{
					// label: "系统发运方式",
                    label: "Carrier Service Code",
					key: "bossSmc",
					span: 24,
					query:this.type=='query',
					props:{
						readonly:true
					},
					children:(h)=>{
						return <vIcon
						type="search"
						center
						slot="suffix"
						style="padding:6px;pointer-events: initial;"
						size="18"
						nativeOnClick={this.handleModalsystem.bind(this)}
					/>
					},
					formItem:{
						style:"width:50%"
					},
				},
				{
					label: "Tracking Method carrier",
					span:24,
					key: "trackingMethodCarrier",
					required:false,
					query:this.type=='query',
					formItem:{
						style:"width:50%"
					},
				},
				{
					label: "Tracking Method Code",
					span:24,
					key: "trackingMethodCode",
					// required:false,
					query:this.type=='query',
					formItem:{
						style:"width:50%"
					},
				},
			];
		},
		getOthernews() {
			return [
				{
					label: "承运商官网Url",
					span:24,
					key: "commonCarrierUrl",
					required:false,
					query:this.type=='query',
					formItem:{
						style:"width:50%"
					},
				},
				{
					label: "备注",
					tag:'vTextarea',
					span:24,
					key: "remark",
					query:this.type=='query',
					required:false,
					formItem:{
						style:"width:50%"
					},
				},
			];
		},
	},
	methods: {
		async getDetail() {
            if (this.type === 'add') return;
            this.loading = true;
            HttpQueryPlatform({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.loading = false;
                this.errorMessage(err.message);
			});
			HttpSysOpLogNew(this.LogformData).then(res=>{
                this.logList = res.data.content
            },err=>{
                this.errorMessage(err.message);
            })
		},
		handleResponse(data={}){
			// console.log(data)
			this.formData = data
		},
		handleModalplat() {
			this.$VModal.info({
				title: "平台名称",
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement("platTablelist",{
						props:{
							accounts:this.getNewAccountList,
							accountTypeList:this.getNewAllAccountIdList,
							countries:this.countries
						},
                        on:{
                            rows:(rows)=>{
								// console.log(rows)
								this.$set(this.formData,'siteName',rows.name)
								this.$set(this.formData,'channelCategoriesId',rows.id)
								this.$set(this.formData,'siteCountry',rows.country)
								// this.formData.siteName = rows.name
                                this.$VModal.destroy();
							},
							cancel:()=>{
								this.$VModal.destroy();
							}
                        }
                    })
				}
			})
		},
		handleModalsystem() {
			this.$VModal.info({
				title: "系统发运方式",
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement("systemTablelist",{
						props:{
							// 'sysdeliveries','syscarrier','sysservice'
							sysdeliveries:this.sysdeliveries,
							// syscarrier:this.syscarrier,
                            syscarrier: this.newSysCarrier,
                            // 换新接口
							sysservice:this.newSysdeliveries.map(item => {
                                return item.carrierServiceCode
                            })
						},
                        on:{
                            rows:(rows)=>{
								// console.log(rows)
								this.$set(this.formData,'bossSmc',rows.carrierServiceCode)
								this.$set(this.formData,'trackingMethodCode',rows.carrierServiceCode)
								// this.formData.bossSmc = rows.carrierCode
                                this.$VModal.destroy();
							},
							cancel:()=>{
								this.$VModal.destroy();
							}
                        }
                    })
				}
			})
		},
		async submit(){
			const valid = await this.$refs['relation'].validate();
			if (!valid) return;
			// console.log(this.formData.shippingS)
			if(this.formData.shippingS==false){
				if(!this.formData.shippingCarrier && !this.formData.shippingMethodCode){
					this.$Message.error('平台Shipping carrier、平台Shipping Service/Method Code 至少填其一');
					return
				}
			}else if(this.formData.shippingS==true){
				this.formData.shippingCarrier = 'DEFAULT'
				this.formData.shippingMethodCode = 'DEFAULT'
			}
            // return console.log(
            //     "参数", 
            //     {
            //         id:this.id,
            //         orgId:global.SYSID,
            //         channelCategoriesId:this.formData.channelCategoriesId,
            //         siteCountry:this.formData.siteCountry,
            //         ...this.formData
            //     }
            // );
			this.loading = true
			HttpSavePlatform({
				id:this.id,
				orgId:global.SYSID,
				channelCategoriesId:this.formData.channelCategoriesId,
				siteCountry:this.formData.siteCountry,
				...this.formData
			}).then(res=>{
				this.$Message.success(res.message);
				this.$router.push({
					name: 'platformlist',
				});
			},err=>{
				this.loading = false;
				this.errorMessage(err.message);
			})
		},
		cancel() {
            this.$router.push({ name: "platformlist" })
        },

	},
}
</script>
